module.exports = __webpack_public_path__ + "img/slideset-text.8e101b85.svg";